import React, { useState } from 'react';
import FloatingLabel from 'floating-label-react';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/style.css';
import { Field } from 'formik';

const MultipleEmailInput = ({ name, placeholder, showErrorMessages = true }) => {
    const [emailState, setEmailState] = useState({
        emails: []
    });
    return (<Field name={name}>
        {({ field, form, meta }) => (
            <div className="app-input-text">
                <ReactMultiEmail
                    placeholder={placeholder}
                    emails={emailState.emails}
                    customInput={FloatingLabel}
                    onChange={(_emails: string[]) => {
                        setEmailState({ emails: _emails });
                        form.setFieldValue(name, _emails);
                    }}
                    validateEmail={email => {
                        return isEmail(email);
                    }}
                    getLabel={(
                        email: string,
                        index: number,
                        removeEmail: (index: number) => void,
                    ) => {
                        return (
                            <div data-tag key={index}>
                                {email}
                                <span data-tag-handle onClick={() => removeEmail(index)}>
                                    ×
                                </span>
                            </div>
                        );
                    }}
                />
                {meta.touched && meta.error && showErrorMessages && (
                    <>{meta.error !== 'email must be a valid email' && <p name={name + 'Error'} className="error-message">{meta.error}</p>}</>
                )}
            </div>
        )}
    </Field>)
}

export default MultipleEmailInput;
